import type { BrandTwoLetterCode, RegionCode } from "brandRegionConfig";
import { centrixFetch } from "core/hooks/useCentrixFetch";
import { getRuntimeEnvironmentVariable } from "./getRuntimeEnvironmentVariable";

export async function fetchPitstopConfiguration() {
  const apiUrl = getRuntimeEnvironmentVariable(
    "API_URL",
    "NEXT_PUBLIC_API_URL"
  );
  if (!apiUrl) {
    throw new Error("API_URL is not configured");
  }
  const res = await centrixFetch(
    {
      path: "/api/app/pitstop-configuration",
      method: "get",
    },
    undefined,
    undefined,
    apiUrl
  );
  if (!res.ok || res.status !== 200) {
    throw new Error(`Invalid status code: ${res.status}`);
  }
  const config = (await res.json()) as Partial<
    Record<BrandTwoLetterCode, RegionCode[]>
  > | null;
  if (!config || typeof config !== "object" || Array.isArray(config)) {
    throw new Error(
      "Invalid Pitstop configuration: expected a brand/country mapping"
    );
  }
  for (const regions of Object.values(config)) {
    if (
      !Array.isArray(regions) ||
      regions.some((region) => typeof region !== "string")
    ) {
      throw new Error(
        "Invalid Pitstop configuration: expected country code arrays"
      );
    }
  }
  return config;
}
